import { render, staticRenderFns } from "./popup-icon.vue?vue&type=template&id=66422d77&scoped=true&"
import script from "./popup-icon.vue?vue&type=script&lang=js&"
export * from "./popup-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66422d77",
  null
  
)

export default component.exports